// extracted by mini-css-extract-plugin
export var accordionWrapper = "QrCode-module--accordionWrapper--3ffea";
export var bullet = "QrCode-module--bullet--b1fb1";
export var container = "QrCode-module--container--83b36";
export var ctaButton = "QrCode-module--ctaButton--25800";
export var gridContainer = "QrCode-module--gridContainer--eac1c";
export var lgBreak = "1200";
export var listSection__inner = "QrCode-module--list-section__inner--6075d";
export var mdBreak = "992";
export var nextSteps = "QrCode-module--nextSteps--f77a4";
export var notice = "QrCode-module--notice--5b018";
export var qrCode = "QrCode-module--qrCode--e0628";
export var smBreak = "768";
export var step = "QrCode-module--step--c77a1";
export var steps = "QrCode-module--steps--863ff";
export var teal = "QrCode-module--teal--13696";
export var textTooltip = "QrCode-module--textTooltip--07053";
export var whatYouNeed = "QrCode-module--whatYouNeed--d9596";
export var xsBreak = "480";